const config = {
  api_base_url_stg: "https://brandify-group-backend.promxa.com/api",
  api_base_url_live: "https://brandify-group-backend.promxa.com/api",
  socket_url: "https://brandify-group-backend.promxa.com:3888",
  whatsapp_api_url: "https://brandify-group-backend.promxa.com:3888",
};
export default config;



